import { render, staticRenderFns } from "./g-textTool.vue?vue&type=template&id=d74b6894&scoped=true&"
import script from "./g-textTool.vue?vue&type=script&lang=js&"
export * from "./g-textTool.vue?vue&type=script&lang=js&"
import style0 from "./g-textTool.vue?vue&type=style&index=0&id=d74b6894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74b6894",
  null
  
)

export default component.exports